/* eslint-disable react/destructuring-assignment */
import React, { FC } from 'react'

import { BuyButtonV1Props } from '@Components/BuyButton/v1'
import { BuyButtonV2 } from '@Components/BuyButton/v2'

export const BuyButton: FC<BuyButtonV1Props> = (props) => {
  const id = props.id || props.product?.id || ''

  return <BuyButtonV2 productID={id} {...props} />
}
